// EUR total of paid service lines (prices in Lek), mirrors backend _service_totals
export function servicesTotalEur(lines, content) {
    const rate = content.currency_lek_per_eur || 100;
    return (lines || []).reduce((sum, l) => {
        const unit = Math.round(((parseFloat(l.price_lek) || 0) / rate) * 100) / 100;
        return sum + unit * (parseInt(l.qty, 10) || 0);
    }, 0);
}
